import React, { FC, useMemo } from 'react';
import { LiquidityWizardMinInfo } from '@app/screens/liquidity/LiquidityWizard/hooks/useDerivedMintInfo';
import LiquidityChart from '@app/screens/liquidity/AddLiquidityV3/components/LiquidityChart';
import { useLiquidityWizardState } from '@app/screens/liquidity/LiquidityWizard/state';
import { useDerivedManualMintInfo } from '@app/screens/liquidity/LiquidityWizard/hooks/useDerivedManualMintInfo';
import { Bound, INITIAL_POOL_FEE } from '@cryptoalgebra/kim-sdk';

interface Props {
  mintInfo: LiquidityWizardMinInfo;
}

export const ManualLiquidityDetails: FC<Props> = ({
  mintInfo: commonMintInfo
}) => {
  // todo - add manual mode content

  const { mode, currencyB, currencyA } = useLiquidityWizardState();
  const { poolAddress } = commonMintInfo;

  const mintInfo = useDerivedManualMintInfo(
    currencyA,
    currencyB,
    poolAddress,
    INITIAL_POOL_FEE,
    currencyA
  );

  const { [Bound.LOWER]: priceLower, [Bound.UPPER]: priceUpper } =
    mintInfo.pricesAtTicks;

  const price = useMemo(() => {
    if (!mintInfo.price) return;

    return mintInfo.invertPrice ? mintInfo.price.invert() : mintInfo.price;
  }, [mintInfo]);

  if (mode !== 'manual') {
    return null;
  }

  return (
    <LiquidityChart
      currencyA={mintInfo.invertPrice ? currencyB : currencyA}
      currencyB={mintInfo.invertPrice ? currencyA : currencyB}
      currentPrice={price ? parseFloat(price.toSignificant()) : undefined}
      priceLower={priceLower}
      priceUpper={priceUpper}
      poolState={mintInfo.poolState}
    />
  );
};
